(function($) {
    //set the options
    $.fn.maphilight.defaults = {
      fill: true,
      fillColor: '1992a4',
      fillOpacity: 0.8,
      stroke: true,
      strokeColor: '1992a4',
      strokeOpacity: 1,
      strokeWidth: 1,
      fade: true,
      alwaysOn: false,
      neverOn: false,
      groupBy: false,
      wrapClass: true,
      shadow: false,
      shadowX: 0,
      shadowY: 0,
      shadowRadius: 6,
      shadowColor: '000000',
      shadowOpacity: 0.8,
      shadowPosition: 'outside',
      shadowFrom: false
    }

    //inti the highlight on the .map
    $('.map').maphilight();
    // console.log('map hightlight')

    //if you needed to highlight points via other divs or items, seen in prototype
    // $( "#squidheadlink" )
    // .on( "mouseover", function() {
    //   // console.log('hover');
    //   $('#id1').mouseover();
    // } )
    // .on( "mouseout", function() {
    //   // console.log('hover');
    //   $('#id1').mouseout();
    // } );

})( jQuery );


//http://jsfiddle.net/ove4trwa/4/
(function($) {
        // Tooltip only Text
        $('.masterTooltip').hover(function(){
                // Hover over code
                var title = $(this).attr('title');
                $(this).data('tipText', title).removeAttr('title');
                $('<p class="tooltip"></p>')
                .text(title)
                .appendTo('body')
                .fadeIn('slow');
        }, function() {
                // Hover out code
                $(this).attr('title', $(this).data('tipText'));
                $('.tooltip').remove();
        }).mousemove(function(e) {
                var mousex = e.pageX + 20; //Get X coordinates
                var mousey = e.pageY - 5; //Get Y coordinates
                $('.tooltip')
                .css({ top: mousey, left: mousex })
        });
})( jQuery );


//used for soft srolling
(function($) {
    // Click event for any anchor tag that's href starts with #
    $('area[href^="#"]').click(function(event) {
        // console.log('href anchor clicked')

        // The id of the section we want to go to.
        var id = $(this).attr("href");

        // An offset to push the content down from the top.
        var offset = 60;

        // Our scroll target : the top position of the
        // section that has the id referenced by our href.
        var target = $(id).offset().top - offset;

        // The magic...smooth scrollin' goodness.
        $('html, body').animate({scrollTop:target}, 500);

        //prevent the page from jumping down to our section.
        event.preventDefault();
    });
})( jQuery );
